import RotateRightIcon from "@mui/icons-material/RotateRight";
import { Box, Card, Stack, Typography } from "@mui/material";

const Fsk8sPageBannerNoData = () => (
  <Card
    sx={{
      width: "100%",
      p: 4,
      display: "flex",
      flexDirection: "column",
      gap: 2,
      borderRadius: 1,
      minHeight: "100%",
    }}
  >
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      flexDirection={{ xs: "column", sm: "row" }}
      sx={{ gap: { xs: 2, sm: 0 } }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "center", sm: "center" } }}
      />
    </Box>
    <Stack spacing={3} alignItems="center" justifyContent="center" flexGrow={1}>
      <Stack spacing={1} textAlign="center">
        <Box>
          <RotateRightIcon color="primary" />
        </Box>
        <Typography variant="h3">We're collecting your cluster data</Typography>
        <Typography color="text.secondary" variant="body1">
          You've successfully installed the agent and we are populating your dashboard.
        </Typography>
        <Typography color="text.secondary" variant="body1">
          This can take up to 24 hours
        </Typography>
      </Stack>
    </Stack>
  </Card>
);

export default Fsk8sPageBannerNoData;
